import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@app/core/graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    BrandFactoryRfqEmails,
    CreateBrandFactoryRfqEmailsInput,
    UpdateBrandFactoryRfqEmailsInput
} from '@app/core/services/api/API.service';
@Injectable({
    providedIn: 'root'
})
export class BrandFactoryRfqEmailsService {
    private amplifyClient = generateClient();
    constructor() {}

    async listBrandFactoryRfqEmails(): Promise<BrandFactoryRfqEmails[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listBrandFactoryRfqEmails,
                    variables: {
                        filter: {
                            status: { eq: true }
                        }
                    }
                })
            ).data.listBrandFactoryRfqEmails.items;
            if (data) return data as BrandFactoryRfqEmails[];
        } catch (error) {
            console.error('Error finding BrandFactoryRfqEmails:', error);
            return null;
        }
    }

    async createBrandFactoryRfqEmails(
        input: CreateBrandFactoryRfqEmailsInput
    ): Promise<BrandFactoryRfqEmails> {
        try {
            const logGanador = (
                await this.amplifyClient.graphql({
                    query: mutations.createBrandFactoryRfqEmails,
                    variables: {
                        input
                    }
                })
            ).data.createBrandFactoryRfqEmails;
            if (logGanador) return logGanador as BrandFactoryRfqEmails;
        } catch (error) {
            console.error('Error creating BrandFactoryRfqEmails:', error);
            return null;
        }
    }

    async updateBrandFactoryRfqEmails(
        input: UpdateBrandFactoryRfqEmailsInput
    ): Promise<BrandFactoryRfqEmails> {
        try {
            const brand = (
                await this.amplifyClient.graphql({
                    query: mutations.updateBrandFactoryRfqEmails,
                    variables: {
                        input
                    }
                })
            ).data.updateBrandFactoryRfqEmails;
            if (brand) return brand as BrandFactoryRfqEmails;
        } catch (error) {
            console.error('Error creating BrandFactoryRfqEmails:', error);
            return null;
        }
    }
}
